export const columns = [
  {
    field: 'name',
    headerName: 'Name',
    width: 6,
  },
];
